export default __webpack_public_path__ + "static/media/mountain-7.f5bc71b5.png";